var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 10.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #001109;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.51,8.87h8.49,0c.23.89,1.03,1.54,1.99,1.54s1.76-.66,1.99-1.54h0,1.5c.28,0,.51-.23.51-.51s-.23-.51-.51-.51h-1.5,0c-.23-.89-1.03-1.54-1.99-1.54s-1.76.66-1.99,1.54h0H.51c-.28,0-.51.23-.51.51s.23.51.51.51ZM10.99,7.19c.64,0,1.16.52,1.16,1.16s-.52,1.16-1.16,1.16-1.16-.52-1.16-1.16.52-1.16,1.16-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.49,1.54H6s0,0,0,0C5.77.66,4.97,0,4.01,0s-1.76.66-1.99,1.54h0H.51C.23,1.54,0,1.77,0,2.06s.23.51.51.51h1.5s0,0,0,0c.23.89,1.03,1.54,1.99,1.54s1.76-.66,1.99-1.54h0,8.49c.28,0,.51-.23.51-.51s-.23-.51-.51-.51ZM4.01,3.22c-.64,0-1.16-.52-1.16-1.16s.52-1.16,1.16-1.16,1.16.52,1.16,1.16-.52,1.16-1.16,1.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.0135ae27f75c7c07790b5bd6ce5f8d3a.svg";
export { ForwardRef as ReactComponent };